// extracted by mini-css-extract-plugin
module.exports = {"tips":"styles_tips__1OR4e","tips-title":"styles_tips-title__1EjTo","tips-content":"styles_tips-content__eOMqG","hidden":"styles_hidden__1ijnr","tipBox":"styles_tipBox__LPa-g"};